import React from 'react'
import { useCollection } from '@morningtrain/react-resources'
import { getMapValue, useEnvValue } from '@morningtrain/react-helpers'
import { autorun } from 'mobx'

export default function WhenOrderCategoryItemsHasSearchedFor ({
  children
}) {
  const collection = useCollection()
  const [envItems] = useEnvValue(['globals.inventory.order_items'].join('.'))
  const [filterByString] = useEnvValue('globals.inventory.filter_order_by_string', '')
  const filterBy = filterByString.trim().toLowerCase()

  function check (collection, envItems) {
    if (!collection || !collection.length) {
      return false
    }

    let hasSearchedFor = false

    collection.forEach(model => {
      const ID = getMapValue(model, 'id')
      let name = getMapValue(model, 'name')
      let sku = getMapValue(model, 'sku')

      if (envItems[ID] && ((name && name.toLowerCase().includes(filterBy)) || (sku && sku.includes(filterBy)))) {
        hasSearchedFor = true
      }
    })

    return hasSearchedFor
  }

  const [shouldRender, setShouldRender] = React.useState(check(collection, envItems))

  React.useEffect(() => {
    const disposer = autorun(() => {
      const shouldRenderCheck = check(collection, envItems)
      if (shouldRenderCheck !== shouldRender) {
        setShouldRender(shouldRenderCheck)
      }
    })

    return () => {
      disposer()
    }
  }, [shouldRender, collection, envItems])

  if (!shouldRender) {
    return null
  }

  return children
}
